const BASE_URL = 'http://43.205.42.216:8000'
// Auth
export const LOGIN_LABORATORY = `${BASE_URL}/laboratory/login/`

// //Common
export const UPLOAD_IMAGE = `${BASE_URL}/common/upload-file/`
// Manage Laboratory

export const LABORATORY_CATEGORY_LISTING = `${BASE_URL}/laboratory/list-category/`
export const ADD_LABORATORY_CATEGORY = `${BASE_URL}/laboratory/add-category/`
export const UPDATE_LABORATORY_CATEGORY = `${BASE_URL}/laboratory/update-category/`
export const DELETE_LABORATORY_CATEGORY = `${BASE_URL}/laboratory/delete-category/`
export const LABORATORY_SUB_CATEGORY_LISTING = `${BASE_URL}/laboratory/list-lab-sub-category/`
export const UPDATE_LABORATORY_SUB_CATEGORY = `${BASE_URL}/laboratory/update-sub-category/`
export const DELETE_LABORATORY_SUB_CATEGORY = `${BASE_URL}/laboratory/delete-sub-category/`
export const ADD_LABORATORY_SUB_CATEGORY = `${BASE_URL}/laboratory/add-sub-category/`
export const LAB_TEST_LISTING = `${BASE_URL}/laboratory/lab-tests/`
